import React from 'react';
import { ArrowRightLeft, CalendarClock, ChevronRight, FileText, Globe, History, LifeBuoy, LogOut, Scale, UserRound } from 'lucide-react';
import { OwnerShell } from '../OwnerShell';
import { StatusBadge } from '../../common/StatusBadge';
import { useOwnerService } from '../../../contexts/OwnerServiceContext';
import { ownerProfile } from '../../../data/ownerProfile';
import { profileTone } from '../../../utils/ownerStatus';
import type { OwnerNav, OwnerScreen } from '../../../types/owner';
const menu: {
  label: string;
  icon: typeof UserRound;
  to: OwnerScreen;
}[] = [{
  label: 'ব্যক্তিগত তথ্য',
  icon: UserRound,
  to: 'profileForm'
}, {
  label: 'আমার আবেদন',
  icon: FileText,
  to: 'tracking'
}, {
  label: 'মেয়াদ সংক্রান্ত সতর্কতা',
  icon: CalendarClock,
  to: 'expiry'
}, {
  label: 'গাড়ির যাচাই ইতিহাস',
  icon: History,
  to: 'history'
}, {
  label: 'ট্রাফিক নোটিশ',
  icon: Scale,
  to: 'notices'
}, {
  label: 'মালিকানা পরিবর্তন সংক্রান্ত আবেদন',
  icon: ArrowRightLeft,
  to: 'ownership'
}, {
  label: 'সহায়তা ও অভিযোগ',
  icon: LifeBuoy,
  to: 'support'
}];
export function OwnerAccount({
  nav
}: {
  nav: OwnerNav;
}) {
  const {
    myProfileStatus,
    ownerId
  } = useOwnerService();
  return <OwnerShell nav={nav} title="প্রোফাইল" back={false} tabs data-id="element-1306" data-mp="2campzotlx4bx">
      <div className="flex items-center gap-3 rounded-xl border border-border bg-white p-4 shadow-sm" data-id="element-1307" data-mp="2cc7g928w213z">
        <img src={ownerProfile.photo} alt="" className="h-16 w-16 rounded-full object-cover" data-id="element-1308" data-mp="2h7d3q5hxvnu6" />
        <div className="min-w-0" data-id="element-1309" data-mp="34ztoint29tx6">
          <p className="font-heading text-lg font-bold text-navy-900" data-id="element-1310" data-mp="390dgze2ow9cz">{ownerProfile.name}</p>
          <p className="text-[12px] text-slate-500" data-id="element-1311" data-mp="2v0uk5hfbwkfz">{ownerProfile.mobile} • {ownerId}</p>
          <StatusBadge tone={profileTone(myProfileStatus)} className="mt-1 !text-[10.5px]" data-id="element-1312" data-mp="2v38iq097wesa">প্রোফাইল {myProfileStatus}</StatusBadge>
        </div>
      </div>
      <ul className="mt-3 divide-y divide-slate-100 overflow-hidden rounded-xl border border-border bg-white" data-id="element-1313" data-mp="1jkxn15xc6u7o">
        {menu.map(m => <li key={m.to} data-id="element-1314" data-mp="1oifns917a34l">
            <button onClick={() => {
          if (m.to === 'ownership') nav.setVehicleId('c1');
          nav.go(m.to);
        }} className="flex w-full items-center gap-3 px-4 py-3.5 text-left text-[14px] text-navy-900 hover:bg-slate-50" data-id="element-1315" data-mp="14j7782yudj1s">
              <m.icon className="h-5 w-5 text-navy-700" data-id="element-1316" data-mp="vpc2gw1mtumo" />
              <span className="flex-1" data-id="element-1317" data-mp="qrakkefy01cs">{m.label}</span>
              <ChevronRight className="h-4 w-4 text-slate-400" data-id="element-1318" data-mp="qqhn642vio7b" />
            </button>
          </li>)}
        <li className="flex items-center gap-3 px-4 py-3.5 text-[14px] text-navy-900" data-id="element-1319" data-mp="ltr6pfn5pqld">
          <Globe className="h-5 w-5 text-navy-700" data-id="element-1320" data-mp="gsbmtqwptq4k" />
          <span className="flex-1" data-id="element-1321" data-mp="crhu8k8bvn5c">ভাষা</span>
          <span className="text-[12px] text-slate-500" data-id="element-1322" data-mp="csawp9097qho">বাংলা</span>
        </li>
      </ul>
      <button onClick={() => nav.reset('login')} className="mt-3 flex w-full items-center justify-center gap-2 rounded-xl border border-red-200 bg-white py-3 text-[14px] font-semibold text-red-700" data-id="element-1323" data-mp="7tgeo9a425ym">
        <LogOut className="h-5 w-5" data-id="element-1324" data-mp="227heawdhiwzr" />লগআউট
      </button>
      <p className="mt-4 text-center text-[11px] text-slate-400" data-id="element-1325" data-mp="29pyoz5x3khub">ডিএমপি গাড়ির মালিক সেবা • সংস্করণ ১.০.০</p>
    </OwnerShell>;
}